import React, { useState, useContext } from "react";
import {
  Box,
  Text,
  Flex,
  FormControl,
  Button,
  Input,
  InputRightElement,
  InputGroup,
  IconButton,
  Heading,
  Container, Spinner, useToast
} from "@chakra-ui/react";
import { useHistory, Link } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import Layout from "../Layout";
import { Logo, IconEye, IconSuccess } from "@assets/Icons";
import { registerCandidate } from "@lib/datahandlers/auth";
import { ModalBox, View, Separator, ErrorBox, CheckBox } from "@components";
import { registerCandidateSchema } from "@lib/validationData";
import { showPasswordHandler } from "@lib/functions";
import { t } from "@lang/i18n";

const RegisterCandidateScreen = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showModalBox, setShowModalBox] = useState(false);

  const history = useHistory();
  const toast = useToast();
  const { register, handleSubmit, setError, formState: { errors } } = useForm({
    resolver: yupResolver(registerCandidateSchema)
  });

  const handleShowClick = () => {
    setShowPassword(!showPassword);
  };
  const checkKeyDown = (e) => {
    if (e.code === 'Enter') e.preventDefault();
  };

  const errorHandling = (obj) => {
    return Object.keys(obj).map(function(key) {
      if (obj[key].length === 1)  setError(key, {
                                    type: "manual",
                                    message: obj[key],
                                  });
      // else return obj[key].join(', ')
      else setError(key, {
            type: "manual",
            message: obj[key],
          });
    });
  };

  const onRegister = async (data) => {
    if (!data.isChecked || data.isChecked === 'undefined') return;
    // delete form.isChecked;
    console.log('data: ', data)

    setIsLoaded(true)
    const result = await registerCandidate(data);

    if (result.success) {
      setIsLoaded(false);
      setShowModalBox(true);
      return;
    }
    setIsLoaded(false);
    if (errorHandling(result.errorMessages)) errorHandling(result.errorMessages)
    // toast({ description: result.errorMessages ? errorHandling(result.errorMessages) : t('messages.error.register'), status: "error", position: "bottom-right", variant: "left-accent", isClosable: true });
  };

  return (
    <Layout isFooterVisible menuType="candidate">
      <View if={showModalBox}>
        <ModalBox isOpen={showModalBox}>
          <Box mb="30px">
            <IconSuccess iconType="candidate" />
          </Box>
          <Text
            color="black"
            textAlign="center"
            fontSize="16px"
            fontWeight="400"
          >
            {t("company.register.success")}
          </Text>

          <Button
            bg="blue.dark"
            borderRadius="24px"
            color="white"
            w="164px"
            py="20px"
            mt="26px"
            _hover={{ bg: "blue.dark", opacity: ".7" }}
            onClick={() => {setShowModalBox(false); history.push('/login')}}
          >
            { t('global.close') }
          </Button>
        </ModalBox>
      </View>
      
      <Container maxW="429px" bg="white" py="39px" px={["16px","","","42px"]} m="63px auto 129px auto" borderRadius="4px" backdropBlur="blur(10px)" opacity=".75">
        <Flex flexDir="column" justifyContent="space-evenly" alignItems="center" textAlign="center">
          <Box mx="auto" mb="16px">
            <Logo logoType="auth" />
          </Box>

          <Box>
            <Text fontWeight="400" fontSize="16px">
              { t('candidate.register.title.t_1') }
              <Box as="span" fontWeight="600">
                { t('candidate.register.title.t_2') }
              </Box>
                { t('candidate.register.title.t_3') }
            </Text>
            <Heading color="blue.dark" fontSize="37px" fontWeight="800">
              { t('candidate.register.find') }
            </Heading>
          </Box>

          <Separator />

        <form onSubmit={handleSubmit(onRegister)} onKeyDown={(e) => checkKeyDown(e)}>
          <Flex flexDir="column">
            <FormControl id="first_name" mb="26px">
              <Input
                type="text"
                placeholder={ t('fields.candidates.first_name') }
                isInvalid={errors.first_name ? true : false}
                focusBorderColor="blue.light"
                errorBorderColor="error"
                borderColor="gray.borders"
                borderRadius="4px"
                bg="white"
                maxW="21.5rem"
                h="46px"
                {...register("first_name")}
              />
              {errors.first_name && <ErrorBox error={errors.first_name.message} />}
            </FormControl>

            <FormControl id="last_name" mb="26px">
              <Input
                type="text"
                placeholder={ t('fields.candidates.last_name') }
                isInvalid={errors.last_name ? true : false}
                errorBorderColor="error"
                borderColor="gray.borders"
                borderRadius="4px"
                bg="white"
                w="21.5rem"
                h="46px"
                focusBorderColor="blue.light"
                {...register("last_name")}
              />
              {errors.last_name && <ErrorBox error={errors.last_name.message} />}
            </FormControl>

            <FormControl id="email" mb="26px">
              <Input
                type="email"
                placeholder={ t('fields.email') }
                isInvalid={errors.email ? true : false}
                errorBorderColor="error"
                borderColor="gray.borders"
                borderRadius="4px"
                bg="white"
                w="21.5rem"
                h="46px"
                focusBorderColor="blue.light"
                {...register("email")}
              />
              {errors.email && <ErrorBox error={errors.email.message} />}
            </FormControl>

            <FormControl id="phone" mb="26px">
              <Input
                type="phone"
                placeholder={ t('fields.candidates.phone') }
                isInvalid={errors.phone ? true : false}
                errorBorderColor="error"
                borderColor="gray.borders"
                borderRadius="4px"
                bg="white"
                w="21.5rem"
                h="46px"
                focusBorderColor="blue.light"
                {...register("phone")}
              />
              {errors.phone && <ErrorBox error={errors.phone.message} />}
            </FormControl>

            <FormControl id="password" mb="26px">
              <InputGroup justifyContent="center">
                <Input
                  type={showPassword ? "text" : "password"}
                  placeholder={ t('fields.password') }
                  isInvalid={errors.password ? true : false}
                  errorBorderColor="error"
                  w="21.5rem"
                  h="46px"
                  borderColor="gray.borders"
                  borderRadius="4px"
                  bg="white"
                  focusBorderColor="blue.light"
                  {...register("password")}
                />

                <InputRightElement top="8%" right="2%">
                  <IconButton
                    onClick={handleShowClick}
                    icon={<IconEye opened={showPasswordHandler(showPassword)} />}
                    bg="invisible"
                    _hover={{ bg: "invisible" }}
                    _focus={{ outline: "none" }}
                    _active={{ bg: "white" }}
                  />
                </InputRightElement>
              </InputGroup>
              {errors.password && <ErrorBox error={errors.password.message} />}
            </FormControl>
          </Flex>
          
          <label className={"custom-checkbox custom-checkbox-register"} tab-index="0" aria-label={"isChecked"}>
              <input type="checkbox" id={"isChecked"} value={true} {...register("isChecked")} />
              <span className={"checkmark candidate"}></span>
              <label className="label" htmlFor={"isChecked"}>
                <Text fontWeight="400" fontSize="14px" my="1rem" maxW="18rem">
                  { t('company.register.conditions.t_1') }
                  <a href={`https://www.visiojob.fr/legal/privacy_notice?type=person`} className="link-password-forgot candidate">
                    { t('company.register.conditions.t_2') }
                  </a>
                  { t('company.register.conditions.t_3') }
                </Text>
              </label>
          </label>
          {errors.isChecked && <ErrorBox error={errors.isChecked.message} />}

          <Button type="submit" w={["75vw",  "18rem", "", ""]} h="40px" borderRadius="24px" bg="blue.dark" color="white"
            _hover={{ bg: "blue.light" }}
            >
            {isLoaded? <Spinner size="md" /> : t("company.register.button")}
          </Button>
        </form>

        <Link to="/login" className="login-link candidate">
          { t('global.login') }
        </Link>
        </Flex>
      </Container>
    </Layout>
  );
};

export default RegisterCandidateScreen;
